import { ofType } from 'redux-observable';
import { delay, mapTo } from 'rxjs/operators';
import { ADD_ALERT_SUCCESS, ADD_ALERT_DANGER } from './actionTypes';
import AlertActions from './actions';

const alertEpic = (action$: any) => action$.pipe(
  ofType(ADD_ALERT_SUCCESS, ADD_ALERT_DANGER),
  delay(7000), 
  mapTo(AlertActions.remove())
);

export default [
  alertEpic
]
